import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="relative mt-20">
      <div className="mx-4 md:mx-6">
        <div className="rounded-2xl bg-foreground-900 px-8 md:px-14 py-14 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
            <div className="md:col-span-1">
              <h3 className="text-white font-heading text-2xl font-semibold mb-2">Itaobuy Sheet</h3>
              <p className="text-foreground-300 text-sm leading-relaxed mt-4">
                La risorsa italiana piu completa per scoprire, organizzare e confrontare prodotti con Itaobuy Spreadsheet.
              </p>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-5">Link Rapidi</h4>
              <ul className="space-y-3">
                <li><Link to="/" className="text-foreground-300 text-sm hover:text-white transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/articolo/guida-completa-itaobuy-spreadsheet" className="text-foreground-300 text-sm hover:text-white transition-colors cursor-pointer">Guida Completa</Link></li>
                <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-300 text-sm hover:text-white transition-colors cursor-pointer">Itaobuy Sheet</a></li>
                <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-300 text-sm hover:text-white transition-colors cursor-pointer">Acquista Ora</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-5">Categorie</h4>
              <ul className="space-y-3">
                <li><a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-300 text-sm hover:text-white transition-colors cursor-pointer">Shoes</a></li>
                <li><a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-300 text-sm hover:text-white transition-colors cursor-pointer">T-Shirts</a></li>
                <li><a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-300 text-sm hover:text-white transition-colors cursor-pointer">Jackets</a></li>
                <li><a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-300 text-sm hover:text-white transition-colors cursor-pointer">Accessories</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold text-sm mb-5">Social</h4>
              <ul className="space-y-3">
                <li>
                  <a href="#" className="flex items-center gap-2 text-foreground-300 text-sm hover:text-white transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-base w-5 h-5 flex items-center justify-center"></i> Instagram
                  </a>
                </li>
                <li>
                  <a href="#" className="flex items-center gap-2 text-foreground-300 text-sm hover:text-white transition-colors cursor-pointer">
                    <i className="ri-youtube-line text-base w-5 h-5 flex items-center justify-center"></i> YouTube
                  </a>
                </li>
                <li>
                  <a href="#" className="flex items-center gap-2 text-foreground-300 text-sm hover:text-white transition-colors cursor-pointer">
                    <i className="ri-facebook-line text-base w-5 h-5 flex items-center justify-center"></i> Facebook
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-foreground-700/30 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-400 text-xs">
              &copy; {new Date().getFullYear()} Itaobuy Spreadsheet Italia. Tutti i diritti riservati.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-foreground-400 text-xs hover:text-foreground-200 transition-colors cursor-pointer">Privacy</a>
              <a href="#" className="text-foreground-400 text-xs hover:text-foreground-200 transition-colors cursor-pointer">Cookie</a>
              <a href="#" className="text-foreground-400 text-xs hover:text-foreground-200 transition-colors cursor-pointer">Disclaimer</a>
            </div>
          </div>

          <div className="mt-8 text-center select-none pointer-events-none">
            <span className="font-heading text-5xl md:text-7xl font-bold text-foreground-800/10 tracking-tight">
              ITAOBUY SPREADSHEET
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}